import { useLoyaltyOffersUiOfferMarketingTilesQuery } from 'generated/sanity-graphql';

export const useLoyaltyOffersMarketingTiles = (): any => {
  const { data } = useLoyaltyOffersUiOfferMarketingTilesQuery({
    variables: {
      id: 'feature-loyalty-offers-ui-singleton',
    },
  });

  const marketingTiles = data?.LoyaltyOffersUI?.loyaltyOffersPageMarketingTiles;

  return { marketingTiles };
};
